// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableRow-module__font-s-10___tLRxG {
  font-size: 10px !important;
}

.TableRow-module__font-s-12___OilHR {
  font-size: 12px !important;
}

.TableRow-module__font-s-13___Z1Ntu {
  font-size: 13px !important;
}

.TableRow-module__font-s-14___BNTAe {
  font-size: 14px !important;
}

.TableRow-module__font-s-15___TGEfk {
  font-size: 15px !important;
}

.TableRow-module__font-s-16___BYrZS {
  font-size: 16px !important;
}

.TableRow-module__font-s-18___QsAFx {
  font-size: 18px !important;
}

.TableRow-module__font-s-20___GYBUo {
  font-size: 20px !important;
}

.TableRow-module__font-s-22___htH08 {
  font-size: 22px !important;
}

.TableRow-module__font-s-28___Y6nFE {
  font-size: 28px !important;
}

.TableRow-module__font-w-400___icrcv {
  font-weight: 400 !important;
}

.TableRow-module__font-w-500___TYGHZ {
  font-weight: 500 !important;
}

.TableRow-module__font-w-600____gGTV {
  font-weight: 600 !important;
}

.TableRow-module__font-w-700___RNFg4 {
  font-weight: 700 !important;
}

.TableRow-module__p-5___CjDsN {
  padding: 5px !important;
}

.TableRow-module__p-12___rCAGs {
  padding: 12px !important;
}

.TableRow-module__p-16___Vzh6t {
  padding: 16px !important;
}

.TableRow-module__p-30___XPj8d {
  padding: 30px !important;
}

.TableRow-module__p-b-0___Lsoke {
  padding-bottom: 0 !important;
}

.TableRow-module__p-b-5___Nb9Y7 {
  padding-bottom: 5px !important;
}

.TableRow-module__p-b-10___WuYCD {
  padding-bottom: 10px !important;
}

.TableRow-module__p-b-12___m908i {
  padding-bottom: 12px !important;
}

.TableRow-module__p-b-16___tbnjh {
  padding-bottom: 16px !important;
}

.TableRow-module__p-b-18___h5slD {
  padding-bottom: 18px !important;
}

.TableRow-module__p-b-20___X7EYG {
  padding-bottom: 20px !important;
}

.TableRow-module__p-b-25___QNUoY {
  padding-bottom: 25px !important;
}

.TableRow-module__p-b-30___fLvz0 {
  padding-bottom: 30px !important;
}

.TableRow-module__p-b-50___aTtAd {
  padding-bottom: 50px !important;
}

.TableRow-module__p-t-0___Du51T {
  padding-top: 0 !important;
}

.TableRow-module__p-t-12___weGaB {
  padding-top: 12px !important;
}

.TableRow-module__p-t-16___tLTrm {
  padding-top: 16px !important;
}

.TableRow-module__p-t-18___XaO8g {
  padding-top: 18px !important;
}

.TableRow-module__p-t-20___pIF7c {
  padding-top: 20px !important;
}

.TableRow-module__p-t-30___wi7rk {
  padding-top: 30px !important;
}

.TableRow-module__p-t-40___D8vB8 {
  padding-top: 40px !important;
}

.TableRow-module__p-t-50___yHta5 {
  padding-top: 50px !important;
}

.TableRow-module__p-l-20___sIq2B {
  padding-left: 20px !important;
}

.TableRow-module__p-l-30___JoS9s {
  padding-left: 30px !important;
}

.TableRow-module__p-l-40___xOuq0 {
  padding-left: 40px !important;
}

.TableRow-module__p-r-16___rHzfW {
  padding-right: 16px !important;
}

.TableRow-module__p-r-20___TA4Um {
  padding-right: 20px !important;
}

.TableRow-module__p-r-30___aUvsY {
  padding-right: 30px !important;
}

.TableRow-module__p-r-50___nfGMI {
  padding-right: 50px !important;
}

.TableRow-module__p-r-60___gboos {
  padding-right: 60px !important;
}

.TableRow-module__m-b-1___ffvRD {
  margin-bottom: 1px !important;
}

.TableRow-module__m-b-2___I60Io {
  margin-bottom: 2px !important;
}

.TableRow-module__m-b-6___F_BSI {
  margin-bottom: 6px !important;
}

.TableRow-module__m-b-8___DKE93 {
  margin-bottom: 8px !important;
}

.TableRow-module__m-b-10___qB3Zn {
  margin-bottom: 10px !important;
}

.TableRow-module__m-b-14___Zbe2G {
  margin-bottom: 14px !important;
}

.TableRow-module__m-b-16___LkkIf {
  margin-bottom: 16px !important;
}

.TableRow-module__m-b-20___lMdWm {
  margin-bottom: 20px !important;
}

.TableRow-module__m-b-22___dKdXD {
  margin-bottom: 22px !important;
}

.TableRow-module__m-b-24___IjTP5 {
  margin-bottom: 24px !important;
}

.TableRow-module__m-b-30___PiWOc {
  margin-bottom: 30px !important;
}

.TableRow-module__m-b-32___Hx2rd {
  margin-bottom: 32px !important;
}

.TableRow-module__m-b-40___YBfYy {
  margin-bottom: 40px !important;
}

.TableRow-module__m-t-2___mfobF {
  margin-top: 2px !important;
}

.TableRow-module__m-t-3___PXJ8P {
  margin-top: 3px !important;
}

.TableRow-module__m-t-4___SljXo {
  margin-top: 4px !important;
}

.TableRow-module__m-t-5___eDHtR {
  margin-top: 5px !important;
}

.TableRow-module__m-t-8___brfKv {
  margin-top: 8px !important;
}

.TableRow-module__m-t-10___p4KNz {
  margin-top: 10px !important;
}

.TableRow-module__m-t-15___l974Y {
  margin-top: 15px !important;
}

.TableRow-module__m-t-16___fLZD_ {
  margin-top: 16px !important;
}

.TableRow-module__m-t-20___fZDyW {
  margin-top: 20px !important;
}

.TableRow-module__m-t-22___QkHMB {
  margin-top: 22px !important;
}

.TableRow-module__m-t-30___WDYyO {
  margin-top: 30px !important;
}

.TableRow-module__m-t-32___PK_aU {
  margin-top: 32px !important;
}

.TableRow-module__m-l-auto___AsHZj {
  margin-left: auto !important;
}

.TableRow-module__m-l-4___rRFSp {
  margin-left: 4px !important;
}

.TableRow-module__m-l-5___zZkPt {
  margin-left: 5px !important;
}

.TableRow-module__m-l-6___NI8nt {
  margin-left: 6px !important;
}

.TableRow-module__m-l-8___uGzZG {
  margin-left: 8px !important;
}

.TableRow-module__m-l-10___tn0l_ {
  margin-left: 10px !important;
}

.TableRow-module__m-l-16___pQvhO {
  margin-left: 16px !important;
}

.TableRow-module__m-l-20___iUwQd {
  margin-left: 20px !important;
}

.TableRow-module__m-l-24___lY5Uy {
  margin-left: 24px !important;
}

.TableRow-module__m-l-30___Agl38 {
  margin-left: 30px !important;
}

.TableRow-module__m-l-35___NMN0q {
  margin-left: 35px !important;
}

.TableRow-module__m-l-40___vhFqb {
  margin-left: 40px !important;
}

.TableRow-module__m-r-8___mvOFk {
  margin-right: 8px !important;
}

.TableRow-module__m-r-10___Z5oeb {
  margin-right: 10px !important;
}

.TableRow-module__m-r-16___FLtCI {
  margin-right: 16px !important;
}

.TableRow-module__m-r-20___SJT6B {
  margin-right: 20px !important;
}

.TableRow-module__m-r-24___N5j_e {
  margin-right: 24px !important;
}

.TableRow-module__m-r-30___VDGpl {
  margin-right: 30px !important;
}

.TableRow-module__m-r-40____canp {
  margin-right: 40px !important;
}

.TableRow-module__border-r-3___QDa6A {
  border-radius: 3px !important;
}

.TableRow-module__border-r-4___o1JyA {
  border-radius: 4px !important;
}

.TableRow-module__border-r-6___Jcrep {
  border-radius: 6px !important;
}

.TableRow-module__border-r-10___frxTW {
  border-radius: 10px !important;
}

.TableRow-module__border-r-12___tA6hx {
  border-radius: 12px !important;
}

.TableRow-module__border-r-16___WxkG5 {
  border-radius: 16px !important;
}

.TableRow-module__border-r-50___b5dMR {
  border-radius: 50% !important;
}

.TableRow-module__primary-border___jh1sG {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TableRow-module__primary-border-b___RwhuV {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TableRow-module__primary-border-t___g8MDX {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TableRow-module__primary-border-l___J2_h3 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TableRow-module__primary-border-r___SMZg7 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TableRow-module__secondary-border____n64S {
  border: 1px solid #637768;
}

.TableRow-module__secondary-border-b___YqVbO {
  border-bottom: 1px solid #637768;
}

.TableRow-module__secondary-border-t___AVACr {
  border-top: 1px solid #637768;
}

.TableRow-module__secondary-border-l___WVzCm {
  border-left: 1px solid #637768;
}

.TableRow-module__secondary-border-r___fcpXB {
  border-right: 1px solid #637768;
}

.TableRow-module__gap-0___LSkLD {
  gap: 0 !important;
}

.TableRow-module__gap-2___AW32b {
  gap: 2px !important;
}

.TableRow-module__gap-4___Ka1w3 {
  gap: 4px !important;
}

.TableRow-module__gap-5___oajoG {
  gap: 5px !important;
}

.TableRow-module__gap-6___vF6ls {
  gap: 6px !important;
}

.TableRow-module__gap-8___ZCs3R {
  gap: 8px !important;
}

.TableRow-module__gap-10___ntigR {
  gap: 10px !important;
}

.TableRow-module__gap-12___xgOIj {
  gap: 12px !important;
}

.TableRow-module__gap-14___VNrmg {
  gap: 14px !important;
}

.TableRow-module__gap-16___gPPRh {
  gap: 16px !important;
}

.TableRow-module__gap-18___lWiWL {
  gap: 18px !important;
}

.TableRow-module__gap-20___SzeMY {
  gap: 20px !important;
}

.TableRow-module__gap-24___iNy5O {
  gap: 24px !important;
}

.TableRow-module__gap-26___BPn1q {
  gap: 26px !important;
}

.TableRow-module__gap-30___GPNAt {
  gap: 30px !important;
}

.TableRow-module__gap-32___ZaH1J {
  gap: 32px !important;
}

.TableRow-module__gap-40___Zh41K {
  gap: 40px !important;
}

.TableRow-module__gap-50___dQzVT {
  gap: 50px !important;
}

.TableRow-module__flex-1___tFuX4 {
  flex: 1;
}

.TableRow-module__flex-none___n9Miu {
  flex: none !important;
}

.TableRow-module__flex-column___XfziR {
  display: flex;
  flex-direction: column !important;
}

.TableRow-module__flex-row___bQG0O {
  display: flex;
  flex-direction: row !important;
}

.TableRow-module__vertically-centered___C2miH {
  display: flex;
  align-items: center !important;
}

.TableRow-module__horizontally-centered___P22yG {
  display: flex;
  justify-content: center !important;
}

.TableRow-module__horizontally-end___Z_qOi {
  display: flex;
  justify-content: end !important;
}

.TableRow-module__vertically-start___HBdBc {
  display: flex;
  align-items: start !important;
}

.TableRow-module__space-between___h07qi {
  display: flex;
  justify-content: space-between !important;
}

.TableRow-module__flex-wrap___Dw1l4 {
  flex-wrap: wrap !important;
}

.TableRow-module__height-100___w6hkA {
  height: 100%;
}

.TableRow-module__width-50___Q7Q2B {
  width: 50% !important;
}

.TableRow-module__width-100___tFUP5 {
  width: 100%;
}

.TableRow-module__cursor-pointer___DlGUk {
  cursor: pointer;
}

.TableRow-module__cursor-not-allowed___xSTF0 {
  cursor: not-allowed !important;
}

.TableRow-module__absolute-centered___iPJBE {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TableRow-module__absolute___dVEIn {
  position: absolute;
}

.TableRow-module__relative___O2ktD {
  position: relative;
}

.TableRow-module__fixed___poAgI {
  position: fixed;
}

.TableRow-module__visible___u1IuH {
  opacity: 1;
}

.TableRow-module__invisible___aTsW_ {
  opacity: 0;
}

.TableRow-module__col-90___O4U46 {
  width: 90% !important;
}

.TableRow-module__col-auto___eM8F9 {
  width: auto !important;
}

.TableRow-module__medical-tabs___i7Q0Q {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TableRow-module__medical-table-new___UEgDl {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TableRow-module__medical-table-new___UEgDl:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TableRow-module__medical-table-new___UEgDl::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TableRow-module__medical-table-new___UEgDl::-webkit-scrollbar-track {
  display: none;
}
.TableRow-module__medical-table-new___UEgDl.TableRow-module__no-pagination___EGtMf {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TableRow-module__medical-table-new___UEgDl.TableRow-module__no-pagination___EGtMf:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TableRow-module__medical-table-new___UEgDl.TableRow-module__no-pagination___EGtMf::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TableRow-module__medical-table-new___UEgDl.TableRow-module__no-pagination___EGtMf::-webkit-scrollbar-track {
  display: none;
}

.TableRow-module__medical-table-empty___ITtsB {
  padding: 14px 40px !important;
}

.TableRow-module__icon-btn___AJQuE {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TableRow-module__search-icon___OBkar {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TableRow-module__disable-select___pGsWp {
  user-select: none;
}

.TableRow-module__break-word___HOecj {
  word-break: break-word;
}

.TableRow-module__popup-clear-btn___ZWy53 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TableRow-module__scroll-m-b-20___pbnwj {
  scroll-margin-bottom: 20px;
}

.TableRow-module__row___SPpTP {
  display: grid;
  padding: 10px 0;
  column-gap: 10px;
  grid-template-columns: 160px repeat(24, minmax(40px, 70px));
}
.TableRow-module__row___SPpTP:not(:last-child) {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}
.TableRow-module__row___SPpTP .TableRow-module__weekday___aeSav {
  color: #859989;
}
.TableRow-module__row___SPpTP .TableRow-module__date___pQx7c {
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/items/TableRow/TableRow.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,2DAAA;AA8pBF;AA5pBE;EACE,8CAAA;AA8pBJ;AA3pBE;EACE,cAAA;AA6pBJ;AA1pBE;EACE,cAAA;AA4pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.row {\n  display: grid;\n  padding: 10px 0;\n  column-gap: 10px;\n  grid-template-columns: 160px repeat(24, minmax(40px, 70px));\n\n  &:not(:last-child) {\n    border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n  }\n\n  .weekday {\n    color: get-color(greenNew, medium);\n  }\n\n  .date {\n    color: get-color(greenNew, dark);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TableRow-module__font-s-10___tLRxG`,
	"fontS12": `TableRow-module__font-s-12___OilHR`,
	"fontS13": `TableRow-module__font-s-13___Z1Ntu`,
	"fontS14": `TableRow-module__font-s-14___BNTAe`,
	"fontS15": `TableRow-module__font-s-15___TGEfk`,
	"fontS16": `TableRow-module__font-s-16___BYrZS`,
	"fontS18": `TableRow-module__font-s-18___QsAFx`,
	"fontS20": `TableRow-module__font-s-20___GYBUo`,
	"fontS22": `TableRow-module__font-s-22___htH08`,
	"fontS28": `TableRow-module__font-s-28___Y6nFE`,
	"fontW400": `TableRow-module__font-w-400___icrcv`,
	"fontW500": `TableRow-module__font-w-500___TYGHZ`,
	"fontW600": `TableRow-module__font-w-600____gGTV`,
	"fontW700": `TableRow-module__font-w-700___RNFg4`,
	"p5": `TableRow-module__p-5___CjDsN`,
	"p12": `TableRow-module__p-12___rCAGs`,
	"p16": `TableRow-module__p-16___Vzh6t`,
	"p30": `TableRow-module__p-30___XPj8d`,
	"pB0": `TableRow-module__p-b-0___Lsoke`,
	"pB5": `TableRow-module__p-b-5___Nb9Y7`,
	"pB10": `TableRow-module__p-b-10___WuYCD`,
	"pB12": `TableRow-module__p-b-12___m908i`,
	"pB16": `TableRow-module__p-b-16___tbnjh`,
	"pB18": `TableRow-module__p-b-18___h5slD`,
	"pB20": `TableRow-module__p-b-20___X7EYG`,
	"pB25": `TableRow-module__p-b-25___QNUoY`,
	"pB30": `TableRow-module__p-b-30___fLvz0`,
	"pB50": `TableRow-module__p-b-50___aTtAd`,
	"pT0": `TableRow-module__p-t-0___Du51T`,
	"pT12": `TableRow-module__p-t-12___weGaB`,
	"pT16": `TableRow-module__p-t-16___tLTrm`,
	"pT18": `TableRow-module__p-t-18___XaO8g`,
	"pT20": `TableRow-module__p-t-20___pIF7c`,
	"pT30": `TableRow-module__p-t-30___wi7rk`,
	"pT40": `TableRow-module__p-t-40___D8vB8`,
	"pT50": `TableRow-module__p-t-50___yHta5`,
	"pL20": `TableRow-module__p-l-20___sIq2B`,
	"pL30": `TableRow-module__p-l-30___JoS9s`,
	"pL40": `TableRow-module__p-l-40___xOuq0`,
	"pR16": `TableRow-module__p-r-16___rHzfW`,
	"pR20": `TableRow-module__p-r-20___TA4Um`,
	"pR30": `TableRow-module__p-r-30___aUvsY`,
	"pR50": `TableRow-module__p-r-50___nfGMI`,
	"pR60": `TableRow-module__p-r-60___gboos`,
	"mB1": `TableRow-module__m-b-1___ffvRD`,
	"mB2": `TableRow-module__m-b-2___I60Io`,
	"mB6": `TableRow-module__m-b-6___F_BSI`,
	"mB8": `TableRow-module__m-b-8___DKE93`,
	"mB10": `TableRow-module__m-b-10___qB3Zn`,
	"mB14": `TableRow-module__m-b-14___Zbe2G`,
	"mB16": `TableRow-module__m-b-16___LkkIf`,
	"mB20": `TableRow-module__m-b-20___lMdWm`,
	"mB22": `TableRow-module__m-b-22___dKdXD`,
	"mB24": `TableRow-module__m-b-24___IjTP5`,
	"mB30": `TableRow-module__m-b-30___PiWOc`,
	"mB32": `TableRow-module__m-b-32___Hx2rd`,
	"mB40": `TableRow-module__m-b-40___YBfYy`,
	"mT2": `TableRow-module__m-t-2___mfobF`,
	"mT3": `TableRow-module__m-t-3___PXJ8P`,
	"mT4": `TableRow-module__m-t-4___SljXo`,
	"mT5": `TableRow-module__m-t-5___eDHtR`,
	"mT8": `TableRow-module__m-t-8___brfKv`,
	"mT10": `TableRow-module__m-t-10___p4KNz`,
	"mT15": `TableRow-module__m-t-15___l974Y`,
	"mT16": `TableRow-module__m-t-16___fLZD_`,
	"mT20": `TableRow-module__m-t-20___fZDyW`,
	"mT22": `TableRow-module__m-t-22___QkHMB`,
	"mT30": `TableRow-module__m-t-30___WDYyO`,
	"mT32": `TableRow-module__m-t-32___PK_aU`,
	"mLAuto": `TableRow-module__m-l-auto___AsHZj`,
	"mL4": `TableRow-module__m-l-4___rRFSp`,
	"mL5": `TableRow-module__m-l-5___zZkPt`,
	"mL6": `TableRow-module__m-l-6___NI8nt`,
	"mL8": `TableRow-module__m-l-8___uGzZG`,
	"mL10": `TableRow-module__m-l-10___tn0l_`,
	"mL16": `TableRow-module__m-l-16___pQvhO`,
	"mL20": `TableRow-module__m-l-20___iUwQd`,
	"mL24": `TableRow-module__m-l-24___lY5Uy`,
	"mL30": `TableRow-module__m-l-30___Agl38`,
	"mL35": `TableRow-module__m-l-35___NMN0q`,
	"mL40": `TableRow-module__m-l-40___vhFqb`,
	"mR8": `TableRow-module__m-r-8___mvOFk`,
	"mR10": `TableRow-module__m-r-10___Z5oeb`,
	"mR16": `TableRow-module__m-r-16___FLtCI`,
	"mR20": `TableRow-module__m-r-20___SJT6B`,
	"mR24": `TableRow-module__m-r-24___N5j_e`,
	"mR30": `TableRow-module__m-r-30___VDGpl`,
	"mR40": `TableRow-module__m-r-40____canp`,
	"borderR3": `TableRow-module__border-r-3___QDa6A`,
	"borderR4": `TableRow-module__border-r-4___o1JyA`,
	"borderR6": `TableRow-module__border-r-6___Jcrep`,
	"borderR10": `TableRow-module__border-r-10___frxTW`,
	"borderR12": `TableRow-module__border-r-12___tA6hx`,
	"borderR16": `TableRow-module__border-r-16___WxkG5`,
	"borderR50": `TableRow-module__border-r-50___b5dMR`,
	"primaryBorder": `TableRow-module__primary-border___jh1sG`,
	"primaryBorderB": `TableRow-module__primary-border-b___RwhuV`,
	"primaryBorderT": `TableRow-module__primary-border-t___g8MDX`,
	"primaryBorderL": `TableRow-module__primary-border-l___J2_h3`,
	"primaryBorderR": `TableRow-module__primary-border-r___SMZg7`,
	"secondaryBorder": `TableRow-module__secondary-border____n64S`,
	"secondaryBorderB": `TableRow-module__secondary-border-b___YqVbO`,
	"secondaryBorderT": `TableRow-module__secondary-border-t___AVACr`,
	"secondaryBorderL": `TableRow-module__secondary-border-l___WVzCm`,
	"secondaryBorderR": `TableRow-module__secondary-border-r___fcpXB`,
	"gap0": `TableRow-module__gap-0___LSkLD`,
	"gap2": `TableRow-module__gap-2___AW32b`,
	"gap4": `TableRow-module__gap-4___Ka1w3`,
	"gap5": `TableRow-module__gap-5___oajoG`,
	"gap6": `TableRow-module__gap-6___vF6ls`,
	"gap8": `TableRow-module__gap-8___ZCs3R`,
	"gap10": `TableRow-module__gap-10___ntigR`,
	"gap12": `TableRow-module__gap-12___xgOIj`,
	"gap14": `TableRow-module__gap-14___VNrmg`,
	"gap16": `TableRow-module__gap-16___gPPRh`,
	"gap18": `TableRow-module__gap-18___lWiWL`,
	"gap20": `TableRow-module__gap-20___SzeMY`,
	"gap24": `TableRow-module__gap-24___iNy5O`,
	"gap26": `TableRow-module__gap-26___BPn1q`,
	"gap30": `TableRow-module__gap-30___GPNAt`,
	"gap32": `TableRow-module__gap-32___ZaH1J`,
	"gap40": `TableRow-module__gap-40___Zh41K`,
	"gap50": `TableRow-module__gap-50___dQzVT`,
	"flex1": `TableRow-module__flex-1___tFuX4`,
	"flexNone": `TableRow-module__flex-none___n9Miu`,
	"flexColumn": `TableRow-module__flex-column___XfziR`,
	"flexRow": `TableRow-module__flex-row___bQG0O`,
	"verticallyCentered": `TableRow-module__vertically-centered___C2miH`,
	"horizontallyCentered": `TableRow-module__horizontally-centered___P22yG`,
	"horizontallyEnd": `TableRow-module__horizontally-end___Z_qOi`,
	"verticallyStart": `TableRow-module__vertically-start___HBdBc`,
	"spaceBetween": `TableRow-module__space-between___h07qi`,
	"flexWrap": `TableRow-module__flex-wrap___Dw1l4`,
	"height100": `TableRow-module__height-100___w6hkA`,
	"width50": `TableRow-module__width-50___Q7Q2B`,
	"width100": `TableRow-module__width-100___tFUP5`,
	"cursorPointer": `TableRow-module__cursor-pointer___DlGUk`,
	"cursorNotAllowed": `TableRow-module__cursor-not-allowed___xSTF0`,
	"absoluteCentered": `TableRow-module__absolute-centered___iPJBE`,
	"absolute": `TableRow-module__absolute___dVEIn`,
	"relative": `TableRow-module__relative___O2ktD`,
	"fixed": `TableRow-module__fixed___poAgI`,
	"visible": `TableRow-module__visible___u1IuH`,
	"invisible": `TableRow-module__invisible___aTsW_`,
	"col90": `TableRow-module__col-90___O4U46`,
	"colAuto": `TableRow-module__col-auto___eM8F9`,
	"medicalTabs": `TableRow-module__medical-tabs___i7Q0Q`,
	"medicalTableNew": `TableRow-module__medical-table-new___UEgDl`,
	"noPagination": `TableRow-module__no-pagination___EGtMf`,
	"medicalTableEmpty": `TableRow-module__medical-table-empty___ITtsB`,
	"iconBtn": `TableRow-module__icon-btn___AJQuE`,
	"searchIcon": `TableRow-module__search-icon___OBkar`,
	"disableSelect": `TableRow-module__disable-select___pGsWp`,
	"breakWord": `TableRow-module__break-word___HOecj`,
	"popupClearBtn": `TableRow-module__popup-clear-btn___ZWy53`,
	"scrollMB20": `TableRow-module__scroll-m-b-20___pbnwj`,
	"row": `TableRow-module__row___SPpTP`,
	"weekday": `TableRow-module__weekday___aeSav`,
	"date": `TableRow-module__date___pQx7c`
};
module.exports = ___CSS_LOADER_EXPORT___;
